import { useEffect, useState } from "react";
import axios from "axios";
import { ExternalLink, ShieldAlert } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/landing`;

export const ScopeHelp = ({ onClose, title }) => {
  const [a, setA] = useState(null);
  useEffect(() => { axios.get(`${API}/shopify-auth`).then((r) => setA(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-2 rounded-xl border border-amber-400/50 bg-amber-400/5 p-4 text-sm text-zinc-200" data-testid="scope-help">
      <p className="flex items-center gap-2 font-semibold text-amber-200"><ShieldAlert className="h-4 w-4" /> {title || "Shopify nu permite încă aplicației să creeze pagini — o singură dată, ~3 minute:"}</p>
      <ol className="list-decimal space-y-1 pl-5 text-xs text-zinc-300">
        <li>Intră pe <b>dev.shopify.com</b> → <b>Apps</b> → aplicația BragusApp (cea cu care e conectat magazinul).</li>
        <li><b>Versions → Create version</b> (sau Configuration → Access) și adaugă la <b>Scopes</b>: {(a?.scopes || []).map((x) => <code key={x} className="mr-1 rounded bg-zinc-800 px-1">{x}</code>)} (păstrează-le pe toate cele existente) → <b>Release</b>.</li>
        <li>La <b>Redirect URLs</b> trebuie să existe: <code className="break-all rounded bg-zinc-800 px-1" data-testid="scope-redirect">{a?.redirect_uri || "…"}</code></li>
        <li>Apasă butonul de mai jos, aprobă în Shopify; când vezi <code>"ok": true</code>, închide tab-ul și reîncearcă acțiunea.</li>
      </ol>
      <div className="flex gap-2">
        {a?.url && <a href={a.url} target="_blank" rel="noreferrer" data-testid="scope-auth-link" className="flex items-center gap-1.5 rounded-full bg-amber-400 px-3 py-1.5 text-xs font-semibold text-zinc-950"><ExternalLink className="h-3.5 w-3.5" /> Autorizează din nou în Shopify</a>}
        <button data-testid="scope-help-close" onClick={onClose} className="rounded-full border border-zinc-700 px-3 py-1.5 text-xs text-zinc-300">Închide</button>
      </div>
    </div>
  );
};
